import { render, staticRenderFns } from "./FaturamentoRead.vue?vue&type=template&id=304c7d04&"
import script from "./FaturamentoRead.vue?vue&type=script&lang=js&"
export * from "./FaturamentoRead.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports